import { useContext, useMemo } from 'react'
import type { ReactElement, ReactNode } from 'react'
import { bindActionCreators } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import { createAppRedux, IAppContextProps } from '@sifrovacihra/shared-ui'
import appReducer, {
    setAppMenuAction,
    setInfoMessageAction,
    setTokenAction,
} from './appSlice'

const actionCreators = { setAppMenuAction, setInfoMessageAction, setTokenAction }

export const { store, AppContext } = createAppRedux(appReducer)

export type TRootState = ReturnType<typeof store.getState>

export const useTypedSelector: TypedUseSelectorHook<TRootState> = useSelector

export const useAction = () => {
    const dispatch = useDispatch()
    return useMemo(() => bindActionCreators(actionCreators, dispatch), [dispatch])
}

export const useAppState = (): IAppContextProps<TRootState['app']> => useContext(AppContext)

export const AppContextProvider = ({ children }: { children?: ReactNode }): ReactElement => {
    const state = useTypedSelector((s) => s.app)
    return <AppContext.Provider value={{ state }}>{children}</AppContext.Provider>
}

export default store
